import { render, staticRenderFns } from "./availability-preview.vue?vue&type=template&id=1671f45d&scoped=true"
import script from "./availability-preview.vue?vue&type=script&lang=js"
export * from "./availability-preview.vue?vue&type=script&lang=js"
import style0 from "./availability-preview.vue?vue&type=style&index=0&id=1671f45d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671f45d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
